export const styles = {
  pdfContainer: {
    height: '64vh',
    overflow: 'auto',
  },
  title: {
    fontSize: 20,
    fontFamily: "'Proxima Nova Alt', sans-serif",
    color: 'black',
    fontWeight: '700',
    width: '100%',
    textAlign: 'center',
    marginBottom: 20,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 20,
    marginBottom: 20,
    width: '100%',
  },
  singleButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 20,
    marginBottom: 20,
    width: '100%',
  },
  pdfWrapper: {
    padding: '20px 12px',
    backgroundColor: '#E4E4EA',
  },
}
